"use client";

import Translations from "@translate/components/Chat/StructuredCards/JsonRender/JsonRenderComponents/FitnessScoreCard/FitnessScoreCardStats";
import { Icon } from "@ospweb/sdk-ui";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export interface FitnessScoreCardStatsProps {
  total: number;
  delta: number;
}

export function FitnessScoreCardStats({
  total,
  delta,
}: FitnessScoreCardStatsProps) {
  const isUp = delta > 0;
  const isDown = delta < 0;

  return (
    <div
      className="flex flex-col gap-0.5 items-start"
      data-testid="fitness-score-card-stats"
    >
      <div className="flex items-end gap-1 overflow-clip">
        <span className="title_xxl text-content_brand_primary">{total}</span>
        <span className="body_medium_m py-1 text-content_quaternary">/100</span>
      </div>

      {isUp ? (
        <div className="flex items-center gap-[3px] overflow-clip">
          <Icon
            name="upvote"
            size={12}
            className="text-content_accent1_primary"
          />
          <span className="body_medium_s text-content_accent1_primary">
            <strong>{delta}</strong> {I18n.t("since last update")}
          </span>
        </div>
      ) : null}

      {isDown ? (
        <div className="flex items-center gap-[3px] overflow-clip">
          <Icon
            name="downvote"
            size={12}
            className="text-content_accent2_primary"
          />
          <span className="body_medium_s text-content_accent2_primary">
            <strong>{Math.abs(delta)}</strong> {I18n.t("since last update")}
          </span>
        </div>
      ) : null}

      {!isUp && !isDown ? (
        <p className="body_medium_s text-content_tertiary">
          {I18n.t("No change")}
        </p>
      ) : null}
    </div>
  );
}
